import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import { useSelect } from '@/pages/activityZkConfig/api';
import React from 'react';
export const SelectZkConfig = ({
  value,
  onChange,
  placeholder = '全部'
}) => {
  const {
    data,
    isLoading
  } = useSelect({
    params: {
      pageSize: 100,
      pageIndex: 1
    }
  });
  const items = data?.data.items ?? [];
  return /*#__PURE__*/React.createElement(_Select, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    loading: isLoading,
    options: items.map(v => ({
      label: v.name,
      value: v.id
    })),
    allowClear: true
  });
};